export async function parseIntegrals(files) {
  const integralData = (await files.integrals.text())
    .split(/\r?\n/)
    .slice(3)
    .filter((t) => t);

  const integrals = [];
  for (let i = 1; i < integralData.length; i++) {
    const data = integralData[i]
      .replace(/^\s*/, '')
      .replace(/[\s\t]+/g, ';')
      .match(/\d+;(?<from>[0-9.]+);(?<to>[0-9.]+);(?<integration>[0-9.]+)/);
    if (data) {
      const { from, to, integration } = data.groups;
      integrals.push({
        from: parseFloat(from),
        to: parseFloat(to),
        integration: parseFloat(integration),
      });
    }
  }

  return integrals;
}
